import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toastError, toastSuccess } from "../../utils/toastrResponse";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import DOMPurify from "dompurify";
import useAxios from "../../hooks/useAxios";

const UpdateSubscriber = ({ show, onHide, subscriber, refreshFunction }) => {
  const [subscriberData, setSubscriberData] = useState({});
  const axiosInstance = useAxios();

  useEffect(() => {
    if (subscriber) {
      const subData = subscriber[0];
      setSubscriberData(subData);
    }
  }, [subscriber]);

  // Onchange Handlers
  const handleOnChangeSubscriber = (e) => {
    const { name, value } = e.target;
    setSubscriberData({
      ...subscriberData,
      [name]: DOMPurify.sanitize(value),
    });
  };

  // Update subscriber and account
  const updateSubscriberDetails = () => {
    const url = `${baseUrl}/subscribers`;
    axiosInstance({
      url,
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: subscriberData,
    })
      .then((res) => {
        if (res.status >= 200 && res.status <= 300) {
          refreshFunction(subscriberData?.id);
          toastSuccess("Subscriber updated successfully");
          onHide();
        } else {
          toastError("Could not update subscriber");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    updateSubscriberDetails();
  };

  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={onHide}>
          <h5>Edit Subscriber Details</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <Form onSubmit={handleSubmit}>
            <label className='ml-2'>Subscriber Id</label>
            <input
              className='form-control input-select mb-2'
              value={subscriberData && subscriberData?.id}
              disabled
            />
            <label className='ml-2'>First name</label>
            <input
              placeholder='First name'
              className='form-control input-select mb-2'
              name='firstName'
              value={subscriberData && subscriberData?.firstName}
              onChange={handleOnChangeSubscriber}
            />
            <label className='ml-2'>Last name</label>
            <input
              placeholder='Last name'
              className='form-control input-select mb-2'
              name='lastName'
              value={subscriberData && subscriberData?.lastName}
              onChange={handleOnChangeSubscriber}
            />
            <label className='ml-2'>Phone number</label>
            <input
              placeholder='Phone number'
              className='form-control input-select mb-2'
              value={subscriberData?.phoneNumber}
              name='phoneNumber'
              onChange={handleOnChangeSubscriber}
            />
            <label className='ml-2'>National Id</label>
            <input
              placeholder='National Id'
              className='form-control input-select mb-2'
              value={subscriberData && subscriberData?.nid}
              name='nid'
              onChange={handleOnChangeSubscriber}
            />
            <label className='ml-2'>Tin number</label>
            <input
              placeholder='Tin number'
              className='form-control input-select mb-2'
              value={subscriberData && subscriberData?.tin}
              name='tin'
              onChange={handleOnChangeSubscriber}
            />
            <div className='d-flex justify-content-center'>
              <Button className='custom-btn-color' type='submit'>
                Save Changes
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UpdateSubscriber;
